// This file is generated by dashboard/scripts/generate-setup-page-i18n.mjs.
// Do not edit manually. Edit setup-messages.json instead.

export const dashboardSetupCatalog = {
  "en": {
    "shared": {
      "connect": "Connect",
      "password": "Wi-Fi password",
      "refresh": "Refresh",
      "setupComplete": "Setup complete",
      "wifiConnectedTitle": "Wi-Fi connected",
      "deviceIp": "Device IP",
      "dashboard": "Dashboard",
      "prepareDashboard": "Prepare dashboard",
      "initialWifiSetup": "Initial Wi-Fi setup",
      "status": "Status",
      "waitingSetup": "Waiting for setup",
      "setupAddress": "Setup address",
      "wifiList": "Wi-Fi networks",
      "signalStrong": "Strong",
      "signalNormal": "Fair",
      "signalWeak": "Weak",
      "openWifiUnsupportedMessage": "Open Wi-Fi networks are not supported. Select a password-protected network.",
      "lockedNetworkPrefix": "Secured · ",
      "openWifiUnsupportedPrefix": "Open Wi-Fi unsupported · ",
      "collapse": "Show less",
      "showMore": "Show {count} more",
      "finishingCountdown": "Finishing setup... {seconds}s",
      "copied": "Copied",
      "apiKeyContinueWithKey": "Copy the API key, then confirm to continue Wi-Fi setup.",
      "apiKeyCheckedMessage": "API key checked. Select Continue to finish Wi-Fi setup.",
      "checkingConnection": "Checking the connection."
    },
    "demo": {
      "title": "Initial Setup",
      "wifiListLoaded": "Nearby Wi-Fi networks loaded.",
      "copy": "Copy",
      "check": "Check",
      "wifiSelectedMessage": "Wi-Fi selected. Enter the password.",
      "selectWifiAgain": "Select Wi-Fi again.",
      "demoListRefreshed": "Demo list refreshed. No real Wi-Fi scan was performed.",
      "selectWifi": "Select Wi-Fi.",
      "passwordMinLength": "Password must be at least 8 characters.",
      "passwordMaxLength": "Password must be 63 characters or fewer.",
      "wifiConnectedMessage": "Wi-Fi connection completed.",
      "finishingSetupMessage": "Finishing setup.",
      "demoDashboardReady": "Demo dashboard is ready.",
      "demoDescription": "This is a demo screen. No real device settings are saved.",
      "nextStep": "Next step",
      "nextStepDescription": "Press prepare dashboard to continue to the demo dashboard.",
      "openDemoDashboard": "Open demo dashboard",
      "demoIntro": "Choose Wi-Fi and enter a password to preview the initial setup flow.",
      "demoNotice": "This screen is only a layout demo. It does not connect Wi-Fi or save anything to ESP32.",
      "wifiName": "Wi-Fi name",
      "change": "Change",
      "apiKeyTitle": "API security key checked",
      "apiKeyDescription": "This key is required when adding the device to Home Assistant. Copy the key, then continue Wi-Fi setup.",
      "wifiConnectingTitle": "Checking Wi-Fi connection",
      "wifiConnectingDescription": "Connecting to the selected Wi-Fi."
    }
  },
  "ko": {
    "shared": {
      "connect": "연결",
      "password": "Wi-Fi 비밀번호",
      "refresh": "새로고침",
      "setupComplete": "설정 완료",
      "wifiConnectedTitle": "Wi-Fi 연결 완료",
      "deviceIp": "기기 IP",
      "dashboard": "대시보드",
      "prepareDashboard": "대시보드 준비",
      "initialWifiSetup": "초기 Wi-Fi 설정",
      "status": "상태",
      "waitingSetup": "설정 대기",
      "setupAddress": "설정 주소",
      "wifiList": "Wi-Fi 목록",
      "signalStrong": "강함",
      "signalNormal": "보통",
      "signalWeak": "약함",
      "openWifiUnsupportedMessage": "오픈 Wi-Fi는 지원하지 않습니다. 비밀번호가 있는 Wi-Fi를 선택하세요.",
      "lockedNetworkPrefix": "잠금 · ",
      "openWifiUnsupportedPrefix": "오픈 Wi-Fi 지원 안 함 · ",
      "collapse": "접기",
      "showMore": "더 보기 {count}개",
      "finishingCountdown": "설정을 마무리하는 중입니다... {seconds}초",
      "copied": "복사됨",
      "apiKeyContinueWithKey": "API 키를 복사한 뒤 확인을 눌러 Wi-Fi 설정을 계속하세요.",
      "apiKeyCheckedMessage": "API 키를 확인했습니다. 계속 버튼을 눌러 Wi-Fi 설정을 마무리하세요.",
      "checkingConnection": "연결을 확인하고 있습니다."
    },
    "demo": {
      "title": "초기 설정",
      "wifiListLoaded": "주변 Wi-Fi 목록을 불러왔습니다.",
      "copy": "복사",
      "check": "확인",
      "wifiSelectedMessage": "Wi-Fi를 선택했습니다. 비밀번호를 입력하세요.",
      "selectWifiAgain": "Wi-Fi를 다시 선택하세요.",
      "demoListRefreshed": "데모 목록을 새로 표시했습니다. 실제 Wi-Fi 검색은 실행하지 않습니다.",
      "selectWifi": "Wi-Fi를 선택하세요.",
      "passwordMinLength": "비밀번호는 8자 이상이어야 합니다.",
      "passwordMaxLength": "비밀번호는 63자 이하여야 합니다.",
      "wifiConnectedMessage": "Wi-Fi 연결을 완료했습니다.",
      "finishingSetupMessage": "설정을 마무리하는 중입니다.",
      "demoDashboardReady": "데모 대시보드 접속 준비가 완료되었습니다.",
      "demoDescription": "데모 화면입니다. 실제 기기 설정은 저장되지 않습니다.",
      "nextStep": "다음 단계",
      "nextStepDescription": "대시보드 준비를 누르면 데모 대시보드로 이동할 수 있습니다.",
      "openDemoDashboard": "데모 대시보드 접속",
      "demoIntro": "Wi-Fi를 선택하고 비밀번호를 입력하면 초기 설정 화면의 흐름을 확인할 수 있습니다.",
      "demoNotice": "이 화면은 레이아웃 확인용 데모입니다. 실제 Wi-Fi 연결이나 ESP32 저장은 실행하지 않습니다.",
      "wifiName": "Wi-Fi 이름",
      "change": "변경",
      "apiKeyTitle": "API 보안 키 확인",
      "apiKeyDescription": "Home Assistant에 기기를 추가할 때 이 키가 필요합니다. 키를 복사한 뒤 Wi-Fi 설정을 계속하세요.",
      "wifiConnectingTitle": "Wi-Fi 연결 확인 중",
      "wifiConnectingDescription": "선택한 Wi-Fi에 연결하고 있습니다."
    }
  }
} as const;
